import axiosServices from '@utils/axios';

const backendUrl = import.meta.env.VITE_BACKEND_URL;

/**
 * Upload a structured codebook (.csv/.xlsx with `codes` + `definition`
 * columns) and get back the parsed rows for the user to confirm before
 * running an analysis.
 *
 * Returns { rows: [{name, definition}], warnings: string[] }.
 *
 * 4xx bodies use the standard FastAPI ``{detail: string}`` shape and
 * should be shown to the user verbatim — the backend writes those
 * messages to be customer-facing.
 */
export async function parseCodebook({ studyId, file }) {
  const form = new FormData();
  form.append('file', file);
  const { data } = await axiosServices.post(
    `${backendUrl}/qualitative-studies/${studyId}/codebook/parse`,
    form,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return data;
}
